import styled from 'styled-components';

import { PageContainer } from 'src/components';
import { BOTTOM_TAB_HEIGHT, DISCLAIMER_HEIGHT } from 'src/constants';
import { HEADER_HEIGHT } from 'src/constants/elementDimensions';

const CUSTOM_HEADER_AND_TOP_MARGIN = 2.4; // NOTE: 0 is tmp it will be 7.2;

export const CustomPageContainer = styled(PageContainer)`
  padding: unset;
  display: flex;
  flex-direction: column;
  justify-self: center;
  width: 100%;
  margin: unset;
`;

export const MainContentWrapper = styled.div`
  display: flex;
  gap: 2.5rem;
  /* NOTE TOP MARGIN HAS EFFECT ON THIS CONSTANT CUSTOM_HEADER_AND_TOP_MARGIN */
  margin: 2.4rem 0rem calc(${BOTTOM_TAB_HEIGHT} + 0.8rem);

  ${({ theme }) => theme.media.laptop`
    margin: 2.4rem 3.2rem;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: 100%;
`;
export const MainContentBoxWRapper = styled.div`
  display: flex;

  padding: 2.4rem 0rem;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  ${({ theme }) => theme.media.laptop`
    padding: 2.4rem 3.2rem;
  `}
`;

export const ChartWrapper = styled(MainContentBoxWRapper)`
  ${({ theme }) => theme.media.laptop`
        padding:2.4rem 0;
    `}
`;

export const TransactionsWrapper = styled.div`
  margin-top: -2.4rem;
  ${({ theme }) => theme.media.laptop`
    margin-top: 0;
  `}
`;

type CoinBalanceWrapperProps = {
  isUnderConstruction?: boolean;
  isAppDisclaimerVisible?: boolean;
};

export const CoinBalanceWraper = styled.div<CoinBalanceWrapperProps>`
  display: none;

  ${({ theme, isUnderConstruction, isAppDisclaimerVisible }) => theme.media
    .laptop`
    height:fit-content;
    position:sticky;

    
    display:block;

    top: ${
      (() => {
        if (isAppDisclaimerVisible && isUnderConstruction) {
          return `${
            HEADER_HEIGHT + DISCLAIMER_HEIGHT * 2 + CUSTOM_HEADER_AND_TOP_MARGIN
          }rem`;
        } else if (isUnderConstruction || isAppDisclaimerVisible) {
          return `${
            HEADER_HEIGHT + DISCLAIMER_HEIGHT + CUSTOM_HEADER_AND_TOP_MARGIN
          }rem`;
        } else {
          return `${HEADER_HEIGHT + CUSTOM_HEADER_AND_TOP_MARGIN}rem`;
        }
      }) as unknown as TemplateStringsArray
    };}


`}
`;

export const MobileCoinBalanceWraper = styled.div`
  display: block;

  ${({ theme }) => theme.media.laptop`

    display:none;
`}
`;
